module.exports = __webpack_public_path__ + "img/testimonial_5.89e47419.png";